import { CardRequestsActions, SET_SELECTED_CARD_REQUEST_ID } from '@Actions/cardRequestsActions';

interface ICardRequestsState {
  selectedCardRequestId: string;
}

export const defaultState: ICardRequestsState = {
  selectedCardRequestId: null
};

export function cardRequestsReducer(state = defaultState, action: CardRequestsActions): ICardRequestsState {
  switch (action.type) {
    case SET_SELECTED_CARD_REQUEST_ID:
      return {
        ...state,
        selectedCardRequestId: action.payload
      };

    default:
      return state;
  }
}
